<template lang="pug">
Button(
  @click="openConfirm($event)"
  v-bind="attrs"
)

//- ConfirmPopup  - shows up right next to the button
//- ConfirmDialog - shows a popup dialog in the center of the screen
//- ConfirmPopup
ConfirmDialog(:group="groupName")
  template(#message="slotProps")
    div(class="flex flex-column align-items-center w-full gap-5")
      i.text-5xl.text-primary-500(:class="slotProps.message.icon")
      p.p-confirm-dialog-message {{ slotProps.message.message }}
</template>

<script setup>
import { useAttrs, getCurrentInstance } from 'vue'
import ConfirmPopup from 'primevue/confirmpopup'
import { useConfirm } from "primevue/useconfirm";
// import { useToast } from "primevue/usetoast";

// Override confirmation config with props
const props = defineProps({
  confirmHeader:  {type: String, default: "Please Confirm" },
  confirmMessage: {type: String, default: "Are you sure you want to proceed?" },
  confirmIcon:    {type: String, default: 'pi pi-exclamation-triangle' },
  confirmButtonLabel: {type: String, default: 'Confirm' },
  rejectButtonLabel:  {type: String, default: 'Cancel' },
  acceptClass:    {type: String, default: 'p-button-sm p-button-danger' },
  rejectClass:    {type: String, default: 'p-button-sm p-button-secondary p-button-outlined' },
})

const attrs   = useAttrs()
const confirm = useConfirm()
const emit    = defineEmits(['onAccept', 'onReject'])
// const toast   = useToast()

// Unique group per instance so multiple ConfirmButtons on the same page
// don't all respond to the same confirm.require() call.
const groupName = `confirm-button-dialog-${getCurrentInstance().uid}`

function openConfirm(event) {
  confirm.require({
    group:        groupName,
    target:       event.currentTarget,
    message:      props.confirmMessage,
    icon:         props.confirmIcon,
    acceptLabel:  props.confirmButtonLabel,
    rejectLabel:  props.rejectButtonLabel,
    acceptClass:  props.acceptClass,
    rejectClass:  props.rejectClass,
    // callback methods
    accept:       onAccept,
    reject:       onReject,
    // the header only shows up on ConfirmDialog (no header in ConfirmPopup)
    header:       props.confirmHeader,
  })
}

function onAccept() {
  // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 })
  emit('onAccept')
}

function onReject() {
  // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 })
  emit('onReject')
}
</script>